import React from 'react';
import { SigningModeType } from '@fiverr-private/identification_core';
import IdentificationForm from '../../components/IdentificationForm';

interface StandaloneIdentificationFormProps {
    mode?: SigningModeType;
    inLynxesIdentificationResetPasswordRollout?: boolean;
}

export const StandaloneIdentificationForm = ({
    mode,
    inLynxesIdentificationResetPasswordRollout,
}: StandaloneIdentificationFormProps) => (
    <IdentificationForm
        mode={mode}
        inLynxesIdentificationResetPasswordRollout={inLynxesIdentificationResetPasswordRollout}
    />
);
